export default "__VITE_ASSET__8501a495__"